const getCheckpointFromPathname = ({ pathname }) => {
  const matches = pathname.match(/^\/discoveries\/[^\/]+(\/[^\/]+)([^\/]+)?$/);

  return matches ? matches[1] : "";
};

export default getCheckpointFromPathname;
